<template>
  <div v-show="isOpen" class="popover">
    <div v-test="{ id: 'popover-content' }" class="mb-8 text-white">
      <slot />
    </div>
    <button
      v-test="{ id: 'popover-close-button' }"
      @click="onClick"
      class="popover-button"
    >
      {{ closeButtonLabel }}
    </button>
  </div>
</template>

<script>
import track from '@/scripts/Track'

export default {
  props: {
    open: {
      type: Boolean,
      default: true
    },
    closeButtonLabel: {
      type: String,
      default: 'OK'
    }
  },
  data() {
    return {
      isOpen: this.open
    }
  },
  methods: {
    onClick() {
      this.isOpen = false
      track({
        message: 'Closed Tooltip',
        code: 'docs.onboarding.close.tooltip'
      })
    }
  }
}
</script>
